import { render, staticRenderFns } from "./course-list.html?vue&type=template&id=466f6a98&scoped=true&"
import script from "./course-list.js?vue&type=script&lang=js&"
export * from "./course-list.js?vue&type=script&lang=js&"
import style0 from "./course-list.css?vue&type=style&index=0&id=466f6a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f6a98",
  null
  
)

export default component.exports